/** Shared docs-site UI constants (URLs come from API). */

export const DOMAIN_STATUS = {
  NOT_CONFIGURED: "not_configured",
  PENDING: "pending",
  VERIFIED: "verified",
  ACTIVE: "active",
  FAILED: "failed",
};

/** Build a public page URL from API settings + page slug. */
export function publicPageUrl(settings, pageSlug = "") {
  if (!settings) return "";
  const path = (pageSlug || "").replace(/^\//, "");
  if (settings.hostingMode === "custom_domain" && settings.customDomain) {
    const base = `https://${settings.customDomain.replace(/\/$/, "")}`;
    return path ? `${base}/${path}` : base;
  }
  const base = (settings.sentrodeskBaseUrl || "").replace(/\/$/, "");
  return path ? `${base}/${path}` : base;
}

/** Format API updatedAt for list display. */
export function formatPageUpdatedAt(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}
